<template>
  <HModal
    :visible="visible"
    :show-close="false"
  >
    <drag-header />
    <div class="pop-wrap new-pay">
      <div
        class="close-btn-wrap"
        @click="closeModal"
      >
        <div class="close-btn sprite-diamond-spring-act sprite-diamond-spring-act-close" />
      </div>
      <div class="act-hd sprite-diamond-spring-act sprite-diamond-spring-act-header-bg">
        <span class="logo sprite-diamond-spring-act sprite-diamond-spring-act-logo" />极光-限时福利
      </div>
      <div class="act-bd">
        <div class="item account-item">
          <div class="item-lt">
            购买账号：
          </div>
          <div class="item-rt">
            {{ userInfo ? userInfo.nickname : '' }}
          </div>
        </div>
        <div
          v-if="noCouponSettingsShow"
          class="pay-setting"
        >
          <div class="item pay-setting-item">
            <div class="item-lt">
              购买金额：
            </div>
            <div class="item-rt">
              <div class="pay-list">
                <ul>
                  <li
                    v-for="(i, idx) in noCouponSettingsShow"
                    :key="i.id"
                    class="pay-item"
                  >
                    <div
                      :class="{
                        active: isActive === idx,
                      }"
                      @click="selPrice(idx, i.id, i)"
                    >
                      <!-- 默认 默认文案小标 1什么都不展示 2倒计时 3图片 -->
                      <span v-if="i.title_type === 1" />
                      <span
                        v-else-if="!i.title_type && i.title"
                        class="tit sprite-icon sprite-icon-pay-title"
                      >{{ i.title }}</span>
                      <div
                        v-else-if="i.title_type === 3 && i.title_img"
                        class="tit-img-3"
                      >
                        <img :src="i.title_img">
                      </div>
                      <div
                        v-else-if="i.title_img"
                        class="tit-img-4"
                      >
                        <img :src="i.title_img">
                      </div>
                      <!-- end 默认 默认文案小标 1什么都不展示 2倒计时 3图片 -->
                      <p class="current-price">
                        <em>￥</em>{{ i.current_price }}
                      </p>
                      <p class="time-line">
                        {{ i.description }}
                      </p>
                      <div class="linear" />
                      <p
                        class="tip"
                        :class="tipClass[i.bottom_type]"
                      >
                        {{ i.bottom }}
                      </p>
                      <em class="active-hook" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="item coupon-item">
            <div class="item-lt">
              限时福利：
            </div>
            <div
              v-for="(item, index) in couponCheckboxs"
              :key="index"
            >
              <div
                v-if="index === isActive"
                class="item-rt"
                :class="{'no-coupon-rt': !item.checked}"
                @click="changeUseCoupon(index)"
              >
                <em>{{ coupons[isActive].coupon }}元</em>极光会员现金券
                <i class="coupon-recommend sprite-diamond-spring-act sprite-diamond-spring-act-recommend" />
                <i
                  v-if="item.checked"
                  class="coupon-select sprite-diamond-spring-act sprite-diamond-spring-act-select"
                />
              </div>
            </div>
          </div>
          <div class="item qrcode-item">
            <div class="item-lt">
              支付金额：
            </div>
            <div class="item-rt">
              <div class="qrcode">
                <img
                  v-if="!loginStatus || isExpires || !qrText"
                  src="@/assets/images/qrcode.png"
                  alt
                  @click="login(9)"
                >
                <qrcode-vue
                  v-else
                  :value="qrText"
                  :size="110"
                  level="H"
                />
              </div>
              <div class="pay-price">
                <p class="current-price">
                  <em>￥</em>{{ total }}
                </p>
                <p class="pay-title">
                  使用<em>微信</em>APP扫码完成支付
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </HModal>
</template>

<script>
import Cookie from 'js-cookie'
import QrcodeVue from 'qrcode.vue'
import { mapGetters, mapActions } from 'vuex'
import client from '@/client/'
import { getPayQrcode, getPayResult, getPaySetting } from '@/api/pay'
import { getPayQrcode as getPayQrcodePdf, getPayResult as getPayResultPdf, getPaySetting as getPaySettingPdf } from '@/api/pdfPay'
import { LOGIN_SERVICE, OCPC_CONVERT_TYPE, REPORT_RELATED } from '@/config/dataMap'
import DragHeader from '@/components/common/DragHeader'
import { updateConvertData } from '@/api/login'

export default {
  components: {
    QrcodeVue,
    DragHeader
  },
  props: {
    visible: Boolean,
    payFrom: Number,
    couponConfig: Object,
    isPdfApi: {
      type: Boolean,
      default: false
    },
    paySuccessTip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      priceId: -1, // 当前支付是哪种会员，settings接口的id
      qrText: '',
      isExpires: false,
      payType: 1,
      hasPay: false,
      isActive: 0,
      // 支付套餐下方文案样式
      tipClass: ['', 'del'],
      couponCheckboxs: [],
      noCouponSettingsShow: [],
      settingsShow: [],
      checked: true,
      qrCodeReportObj: { // 二维码展示上报,字段参考duba_tech_monitor_qrcode表
        action: 1,
        qr_type: 1,
        err_code: ''
      },
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'openId',
      'loginStatus',
      'isMember',
      'userInfo',
      'isTourist'
    ]),
    coupons () {
      const couponList = []
      this.settingsShow.forEach((settingItem, index) => {
        couponList[index] = 0
        this.couponConfig.coupons.forEach(couponItem => {
          if (settingItem.month_length === couponItem.month_length) {
            couponList[index] = couponItem
          }
        })
      })

      return couponList
    },
    total () {
      return (
        (this.curSetting &&
          this.curSetting.current_price) ||
        0
      )
    },
    curSetting () {
      return this.settingsShow[this.isActive]
    },
    is_trust () {
      return false
    },
    // 下单类型
    orderPayType () {
      // web_entrust 纯签约方式下单
      // wx_qrcode 微信二维码支付
      // alipay_qrcode 支付宝二维码支付
      // alipay_cyclepaysign 支付宝周期扣款（支付并签约)
      // wx_web 微信支付跳到h5 or jsapi
      // 纯签约
      if (this.is_trust) {
        return this.payType === 1 ? 'web_entrust' : 'alipay_cyclepaysign'
      }
      // 非纯签约逻辑
      // 微信支付
      if (this.payType === 1) {
        return 'wx_qrcode'
      }
      // 支付宝支付，自动续费的套餐使用alipay_cyclepaysign,否则就使用普通二维码支付
      return this.curSetting.is_entrust_setting === 1
        ? 'alipay_cyclepaysign'
        : 'alipay_qrcode'
    }
  },
  async created () {
    await this.getUseCouponPayInfo()
    await this.getNoCouponPayInfo()
    this.settingsShow = [...this.useCouponSetting]
    this.noCouponSettingsShow = [...this.noCouponSetting]
    this.setCouponCheckboxs()
    this.getQrCodeByServer()
  },
  methods: {
    ...mapActions(['refresh']),
    login () {
      if (this.loginStatus) {
        this.getQrCodeByServer()
        return
      }
      client.common.API.userLogin({ url: LOGIN_SERVICE.url })
    },

    changeUseCoupon (index) {
      const checked = !this.couponCheckboxs[index].checked
      this.couponCheckboxs[index].checked = checked
      const newSetting = checked ? this.useCouponSetting[index] : this.noCouponSetting[index]
      this.checked = checked

      this.$set(this.settingsShow, index, newSetting)
      this.getQrCodeByServer()
      this.$emit('changeCoupon', this.coupons[this.isActive].couponID)
    },
    selPrice (idx, id) {
      this.isActive = idx
      this.$emit('changePay', id)
      if (this.priceId === id) {
        return
      }
      this.priceId = id
      this.getQrCodeByServer()
    },
    setCouponCheckboxs () {
      const checkboxs = []
      this.settingsShow.forEach(() => {
        checkboxs.push({
          checked: true
        })
      })
      this.couponCheckboxs = checkboxs
    },
    async getUseCouponPayInfo () {
      this.useCouponSetting = await this.getPayInfo(this.couponConfig.useCouponShow)
    },
    async getNoCouponPayInfo () {
      this.noCouponSetting = await this.getPayInfo(this.couponConfig.noCouponShow)
    },
    async getPayInfo (show) {
      const { openId } = this
      const reqData = {
        open_id: this.isTourist ? '' : openId,
        is_continuous: 0,
        time_type: 0,
        show
      }

      const data = this.isPdfApi ? await getPaySettingPdf(reqData) : await getPaySetting(reqData)
      const result = data
      if (result) {
        return result.pay_price_settings
      }
      return []
    },
    /**
     * 默认使用Cookie获取show_from
     * 极光会员红包挽留活动 使用优惠券：6303 未使用优惠券：6304
     */
    getShowFrom () {
      let show_from = Number(Cookie.get('show_from')) || 0
      if (this.isPdfApi) {
        show_from = this.checked ? 6303 : 6304
      }
      return show_from
    },

    /* eslint-disable-next-line */
    async getQrCodeByServer () {
      if (!this.loginStatus || this.isTourist || !this.openId) return
      const show_from = this.getShowFrom()

      this.qrCodeLoadedReport(REPORT_RELATED.qr_show.api_begin)
      const reqData = {
        open_id: this.openId, // 用户openid
        pay_setting_id: this.curSetting.id,
        pay_type: this.orderPayType,
        is_first_order: this.curSetting.is_first_order,
        pay_from: this.payFrom || 0,
        server_id: Cookie.get('svrid') || '',
        uuid: Cookie.get('uuid') || '',
        pay_channel: this.payType,
        show_from,
        token: this.token,
        vip_version: Cookie.get('vip_version') || '',
        tid1: this.$TidObj.tid1 || 0,
        tid2: this.$TidObj.tid2 || 0,
        tod1: this.$TidObj.tod1 || 0,
        tod2: this.$TidObj.tod2 || 0
      }
      const data = this.isPdfApi ? await getPayQrcodePdf(reqData) : await getPayQrcode(reqData)
      this.isExpires = false
      if (data && data.resp_common && data.resp_common.ret !== 0) {
        client.techMonitor.REPORT.fetmReportQrcode({ err_code: data.resp_common.ret })
      }
      const result = this.isRenderData(data)
      if (result) {
        this.qrCodeLoadedReport(REPORT_RELATED.qr_show.api_success)
        // entrust_url 微信纯签约，alipay_cyclepaysign_url 支付宝周期扣款（支付并签约)
        // wxqrcode_url 微信普通支付 alipayqrcode_url 支付宝普通支付
        const url =
          result.entrust_url ||
          result.alipay_cyclepaysign_url ||
          result.wxqrcode_url ||
          result.alipayqrcode_url

        if (url) {
          this.qrText = url
          this.orderId = result.order_id || result.id
          this.isExpires = false
          this.renderQrcallback()
        }
      }
    },
    qrCodeLoadedReport (qr_show) {
      const curObj = {
        payid: this.curSetting.id,
        payid_time: this.curSetting.month_length,
        payway: this.pay_type,
        qr_show
      }
      client.techMonitor.REPORT.fetmReportQrcode(Object.assign({}, curObj, this.qrCodeReportObj))
    },
    renderQrcallback () {
      this.clearLoopTimer()
      // 支付二维码生成完成，开始轮询支付结果接口
      let hour = 3600
      const time = 3
      this.loopPayResultTimer = setInterval(async () => {
        hour = hour - time
        // 一小时有效期
        if (hour > 0) {
          const reqData = {
            common: {
              token: this.token
            },
            order_id: this.orderId,
            pay_channel: this.payType,
            pay_type: this.orderPayType
          }
          const data = this.isPdfApi ? await getPayResultPdf(reqData) : await getPayResult(reqData)
          const result = this.isRenderData(data)
          // 0订单支付成功,7001001为支付失败,7001002未支付,7001003支付关闭,7001005没有此订单
          if (result.data && result.data.status === 0) {
            this.clearLoopTimer()
            // 刷新用户状态，跳转到首页
            client.common.API.paySuccess({ token: this.token, open_id: this.openId })
            this.paySuccessCallback()
          }
        } else {
          this.clearLoopTimer()
          this.isExpires = true
        }
      }, time * 1000)
    },
    isRenderData (data) {
      try {
        if (data && data.resp_common && data.resp_common.ret === 0) {
          return data
        }
        this.errerTips()
        return false
      } catch (e) {
        this.errerTips()
        return false
      }
    },

    errerTips () {
      this.$toast('获取支付信息异常')
    },

    paySuccessCallback () {
      client.common.API.getOcpcUrl().then(res => {
        updateConvertData({
          conversion_info: {
            long_code: res.logidUrl,
            convert_type: OCPC_CONVERT_TYPE.BUY,
            user_type: res.userType > 0 ? res.userType : 1,
          }
        })
      })
      this.hasPay = true
      const monthLength = this.curSetting.month_length
      this.$emit('paySuccess')
      // 优先弹传入的支付成功提示
      if (this.paySuccessTip) {
        this.$toast(this.paySuccessTip, { duration: 5000 })
      } else {
        this.$toast(monthLength === 1200 ? '您已充值钻石会员，已荣登真爱榜！' : '支付成功', { duration: 5000 })
      }
      this.getPayInfo()
      this.closeModal()
    },

    clearLoopTimer () {
      if (this.loopPayResultTimer) clearInterval(this.loopPayResultTimer)
    },
    closeModal () {
      this.$emit('closeModal', this.hasPay)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixins.scss';
@import '@/assets/css/sprite-diamond-spring-act.scss';

.new-pay {
  position: relative;
  @mixin pay_price_bg(
    $bg: #fff,
    $bcor: #d9d9d9,
    $hover_bcor: #adc4d9,
    $ac_bcor: #eb5350,
    $ac_shadow: #e8f2fc,
    $span_cor: #333
  ) {
    border-radius: 4px;
    vertical-align: middle;
    height: 90px;
    line-height: 20px;
    background: $bg;
    cursor: pointer;
    border: solid 1px $bcor;
    // cursor: pointer;
    &:hover {
      border: solid 1px $ac_bcor;
    }
    &.active {
      border: solid 1px transparent;
      box-shadow: 0 0 0 2px red;
      height: 86px;
      border-radius: 5px;
      margin-top: 2px;
      background-color: #fffcef;
      .active-hook {
        position: absolute;
        right: -2px;
        bottom: 0px;
        width: 17px;
        height: 17px;
        background: transparent url(~@/assets/images/pay-select.png) no-repeat
          right bottom;
      }
      .current-price {
        padding-top: 7px;
      }
      .time-line {
        font-weight: bold;
      }
    }

    .tit-img {
      position: absolute;
      left: -11px;
      top: -17px;
      width: 157px;
      height: 44px;
    }
    .tit-img-3 {
      position: absolute;
      left: -4px;
      top: -22px;
      height: 29px;
      img {
        height: 100%;
      }
    }
    .tit-img-4 {
      height: 26px;
      position: absolute;
      top: -19px;
      left: -4px;
      img {
        height: 100%;
      }
    }
    .tit-time-limit {
      .time-limit {
        color: #de461e;
        height: 26px;
        width: 112px;
        padding-left: 4px;
        box-sizing: border-box;
        position: absolute;
        left: -4px;
        top: -19px;
        font-size: 12px;
      }
      span {
        display: inline;
        font-size: 12px;
        line-height: 24px;
        color: #de461e;
      }
      .tit {
        line-height: 20px;
      }
      .time-span {
        color: #fff;
        display: inline-block;
        width: 18px;
        text-align: center;
        box-sizing: border-box;
        background: #dc320a;
        border-radius: 2px;
        margin-top: -3px;
        line-height: 16px;
        vertical-align: middle;
        overflow: hidden;
      }
      .time-em {
        display: inline-block;
        width: 8px;
        font-style: normal;
      }
    }
    span {
      &.tit {
        position: absolute;
        float: left;
        color: #fff;
        font-size: 12px;
        height: 26px;
        line-height: 24px;
        top: -19px;
        left: -4px;
      }
      &.tit2 {
        display: inline-block;
        margin-top: 35px;
        font-size: 14px;
        max-height: 18px;
        max-width: 96px;
        overflow: hidden;
      }
      &.tit3 {
        margin: 5px;

        font-size: 14px;
        position: relative;
        del {
          color: #909090;
        }
        &.show-next {
          font-size: 12px;
          line-height: 1;
          margin-top: 0;
          color: #909090;
          margin-top: 2px;
          p {
            margin-top: 5px;
          }
        }
      }
      &.price {
        display: inline-block;
        color: #de461e;
        margin-top: 30px;
        max-width: 96px;
        em {
          font-style: normal;
          font-size: 24px;
          vertical-align: 1px;
        }
        letter-spacing: -1px;
        font-size: 28px;
      }
      display: block;
      color: $span_cor;
    }
  }
  ul {
    margin-left: 11px;
    transition: 0.35s 0s ease;
    display: flex;
    &.scroll-right {
      transform: translateX(-63px);
    }
    li {
      text-align: center;
      position: relative;
      width: 117px;
      & > div {
        @include pay_price_bg;
      }
      .supermebertabshow {
        border: 1px solid rgba(241, 211, 197, 1);
        &.active {
          background: url(~@/assets/images/pay-select-bg.png) no-repeat -1px -2px;
        }
      }
    }
  }
  .bottom {
    position: relative;
    height: 140px;
    width: 642px;
    margin-left: 24px;
    box-sizing: border-box;
    font-size: 12px;
    background: #f4f6fa;
    .pay_type {
      float: left;
      margin-bottom: 12px;
      dt {
        font-size: 16px;
        padding-bottom: 10px;
      }
      dd {
        width: 256px;
      }
      span {
        margin-left: 34px;
        cursor: pointer;
      }
      span:nth-child(1) {
        margin-top: 19px;
        margin-bottom: 10px;
      }
    }
    dt {
      color: #333;
      font-size: 14px;
      margin-bottom: 2px;
      padding-left: 6px;
    }
    dd {
      font-size: 14px;
      color: #8d8e93;
    }
    p {
      padding-left: 6px;
    }
    span.total {
      color: #de461e;
      font-size: 36px;
      margin-left: -4px;
      em {
        font-style: normal;
        font-size: 20px;
        margin-right: -1px;
        vertical-align: 1px;
      }
      .total_off {
        color: #8d8e93;
        font-size: 14px;
      }
      letter-spacing: -1px;
    }
    .ali-total {
      font-size: 48px;
      color: #de461e;
      position: absolute;
      bottom: 41px;
      left: 15px;
      line-height: 1;
    }
    .wechat-guide {
      position: absolute;
      right: 0;
      bottom: -18px;
      z-index: 1;
    }
    .diamond-desc {
      margin: 17px 0 0 14px;
      font-size: 14px;
      color: #545454;
      p {
        margin-bottom: 2px;
        padding-left: 0;
      }
      i {
        width: 4px;
        height: 4px;
        background: rgba(141, 142, 147, 1);
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }
      .title {
        font-size: 14px;
        color: #b07400;
        background: #fff1ce;
        border: 1px solid #cba864;
        border-radius: 2px;
        width: 79px;
        height: 13px;
        line-height: 13px;
        padding: 2px;
      }
    }
  }
  .notice {
    color: #8d8e93;
    margin-bottom: 18px;
    height: 16px;
  }
  .dl_total {
    float: left;
    padding-top: 34px;
    dd {
      padding-left: 15px;
    }
  }
  .qrcode {
    float: left;
    color: #8d8e93;
    padding-top: 10px;
    text-align: center;
    width: 120px;
    height: 120px;
    position: relative;
    img {
      margin-bottom: 10px;
      cursor: pointer;
    }
    img,
    span {
      display: block;
    }
  }
  .pay_title {
    padding-left: 10px;
    em {
      margin: 0 4px;
      font-style: normal;
      color: #de461e;
    }
  }
  .pay-title-wrap {
    display: flex;
    align-items: center;
    color: #545454;
    font-size: 14px;
    em {
      color: #18c048;
      font-style: normal;
      font-weight: bold;
    }
    .alipay-tit {
      color: #3875f6;
    }
    .doubt-wrap {
      padding: 0 10px 10px 0;
    }
    i {
      margin-left: 6px;
      position: relative;
      top: -2px;
    }
  }
  .pay-list {
    width: 455px;
    height: 98px;
    padding-top: 33px;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
  }
  .pay-item-w {
    margin-bottom: 30px;
  }
  .pay-item {
    margin-left: 13px;

    &:last-of-type {
      margin-right: 4px;
    }
  }
  .current-price {
    padding-top: 9px;
    font-size: 28px;
    color: #de461e;
    line-height: 1;
    em {
      font-size: 18px;
      font-style: normal;
    }
  }
  .time-line {
    font-size: 14px;
    color: #545454;
    margin-top: 6px;
    line-height: 1;
  }
  .linear {
    width: 100%;
    position: absolute;
    bottom: 27px;
    height: 1px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 10%,
      rgba(157, 157, 157, 0.3) 20%,
      rgba(157, 157, 157, 0.4) 30%,
      rgba(157, 157, 157, 0.5) 40%,
      rgba(157, 157, 157, 0.8) 50%,
      rgba(157, 157, 157, 0.5) 60%,
      rgba(157, 157, 157, 0.4) 70%,
      rgba(157, 157, 157, 0.3) 80%,
      rgba(0, 0, 0, 0) 90%,
      rgba(0, 0, 0, 0) 100%
    );
  }
  .supermebertabshow .linear {
    width: 100%;
    position: absolute;
    bottom: 27px;
    height: 1px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 10%,
      rgba(223, 110, 57, 0.3) 20%,
      rgba(223, 110, 57, 0.4) 30%,
      rgba(223, 110, 57, 0.5) 40%,
      rgba(223, 110, 57, 0.8) 50%,
      rgba(223, 110, 57, 0.5) 60%,
      rgba(223, 110, 57, 0.4) 70%,
      rgba(223, 110, 57, 0.3) 80%,
      rgba(0, 0, 0, 0) 90%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  .tip {
    font-size: 14px;
    color: #888;
    line-height: 25px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    &.del {
      text-decoration: line-through;
    }
  }
  .renew {
    padding-left: 24px;
    margin-bottom: 15px;
    font-size: 14px;
    color: #7a7a7a;
    a {
      color: #b07400;
      cursor: pointer;
    }
  }
  .checkbox {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(~@/assets/images/sprite.png) no-repeat;
    background-position: -166px -331px;
    margin-right: 10px;
    position: relative;
    top: 1.5px;
    cursor: pointer;
    &.isActive {
      background-position: -152px -331px;
    }
  }
  .ali-pay {
    position: absolute;
    right: 70px;
    bottom: 26px;
    text-align: center;
    color: #8d8e93;
    font-size: 14px;
    line-height: 1;
    span {
      color: #de461e;
    }
  }
  .pay-btn {
    height: 40px;
    line-height: 40px;
    text-align: center;
    width: 100px;
    cursor: pointer;
    color: #11a9eb;
    border: 1px solid #11a9eb;
    border-radius: 5px;
    margin: 0 auto 10px;
    &:hover {
      color: #fff;
      background: #11a9eb;
    }
  }
  .is-disabled {
    color: #cacaca;
    cursor: not-allowed;
    visibility: hidden;
    .checkbox {
      cursor: not-allowed;
      background: url(~@/assets/images/grey-checkbox.png) no-repeat center
        center;
    }
    a {
      color: #cacaca;
      cursor: not-allowed;
    }
  }
}
.pay-item-w {
  margin-bottom: 30px;
}
.pay-item {
  margin-left: 13px;

  &:last-of-type {
    margin-right: 4px;
  }
}
.current-price {
  padding-top: 9px;
  font-size: 28px;
  color: #de461e;
  line-height: 1;
  em {
    font-size: 18px;
    font-style: normal;
  }
}
.time-line {
  font-size: 14px;
  color: #545454;
  margin-top: 6px;
  line-height: 1;
}
.linear {
  width: 100%;
  position: absolute;
  bottom: 27px;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) 10%,
    rgba(157, 157, 157, 0.3) 20%,
    rgba(157, 157, 157, 0.4) 30%,
    rgba(157, 157, 157, 0.5) 40%,
    rgba(157, 157, 157, 0.8) 50%,
    rgba(157, 157, 157, 0.5) 60%,
    rgba(157, 157, 157, 0.4) 70%,
    rgba(157, 157, 157, 0.3) 80%,
    rgba(0, 0, 0, 0) 90%,
    rgba(0, 0, 0, 0) 100%
  );
}
.tip {
  font-size: 14px;
  color: #888;
  line-height: 25px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  &.del {
    text-decoration: line-through;
  }
}
.pop-wrap {
  width:600px;
  height:420px;
  background-color: #fff;
  .close-btn-wrap {
    position: absolute;
    top: 3px;
    right: 3px;
    width: 24px;
    height: 24px;
    overflow: hidden;
    cursor: pointer;
    z-index: 10;
    .close-btn {
      position: relative;
      &:hover {
        left: -24px;
      }
      &:active {
        left: -48px;
      }
    }
  }
  .act-hd {
    box-sizing: border-box;
    padding-left: 8px;
    line-height: 30px;
    color: #fce2ac;
    font-size:12px;
    .logo {
      margin-right: 4px;
    }
  }
  .act-bd {
    padding: 19px 50px 0 42px;
    color: #545454;
    font-size: 12px;
    .item {
      margin-bottom: 15px;
      display: flex;
      .item-lt {
        margin-right: 15px;
      }
    }

    .account-item {
      margin-bottom: 33px;
    }

    .pay-setting-item {
      .item-rt {
        position: relative;
        height: 126px;
        box-sizing: border-box;
        border-radius: 4px;
        margin: -33px 0 0 -22px;
      }
    }

    .coupon-item {
      .item-rt {
        position: relative;
        width:430px;
        height:47px;
        box-sizing: border-box;
        border: 2px solid #F10000;
        border-radius: 4px;
        line-height: 47px;
        text-indent: 35px;
        font-size:16px;
        cursor: pointer;
        em {
          color: #f10000;
          font-style: normal;
        }
        .coupon-recommend {
          position: absolute;
          top: 0;
          left: 0;
        }
        .coupon-select {
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      .no-coupon-rt {
        border: 1px solid #D9D9D9;
      }
    }

    .qrcode-item {
      .item-rt {
        display: flex;
        align-items: center;
        width:430px;
        height:128px;
        box-sizing: border-box;
        padding: 9px 11px;
        background-color: #F4F6FA;
        .qrcode {
          img {
            width: 110px;
            height: 110px;
          }
          margin-right: 27px;
        }
        .current-price {
          font-size: 41px;
          color: #f10000;
          em {
            font-size: 14px;
            font-style: normal;
          }
        }
        .pay-title {
          em {
            color: #f10000;
            font-style: normal;
          }
        }

      }
    }

  }
}

</style>
